<div class="location-container" [ngClass]="{extend:!isMenuDeployed,reduce:isMenuDeployed}">
  <div class="location-bar" [ngClass]="{'bar-hide':isHide}">
      <a class="item first-item">
        <i class="material-icons back">arrow_back</i>
      </a>

      <span id="location" class="item">
        <!--{{ back || 'back to list'}}-->
      </span>

      <a href="#" class="item">location</a>
      <a class="item">
        <i class="material-icons back">keyboard_arrow_right</i>
      </a>
      <a href="#" class="item">location</a>
  </div>
</div>
